module.exports = __webpack_public_path__ + "static/img/shuiSwiper.513dd43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/shuiSwiper.jpg
// module id = CEVK
// module chunks = 0